var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.step.is,_vm._b({tag:"component",staticClass:"step",attrs:{"disabled":!_vm.viewValidState && _vm.step.event.validate},on:{"click":_vm.onClick}},'component',_vm.step.options,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }